import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Alert } from 'antd'

import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'

import { IFilter } from '@vacationtracker/shared/types/filter'

interface IBirthdaySummaryInfoProps {
  filters: IFilter
  totalUsers: number
  totalUsersWithBirthdayDate: number
  canImportUsers: boolean
}

const BirthdaySummaryInfo = ({ filters, totalUsers, totalUsersWithBirthdayDate, canImportUsers }: IBirthdaySummaryInfoProps): ReactElement => {
  let linkTo = '/app/users?saveFilters=false'

  if (filters.locationIds?.length) {
    linkTo += `&locations=${filters.locationIds.join(',')}`
  }
  if (filters.teamIds?.length) {
    linkTo += `&departments=${filters.teamIds.join(',')}`
  }
  if (filters.labelIds?.length) {
    linkTo += `&labels=${filters.labelIds.join(',')}`
  }

  const getSummaryMessage = (): ReactElement => {
    if (totalUsersWithBirthdayDate === 0) {
      return (
        <IntlMessages
          id="components.birthdaySummaryInfo.noUsersHaveBirthdays"
          values={{
            importLink: (...chunks) => (canImportUsers ? <Link to="/app/import/details">{chunks}</Link> : <>{chunks}</>),
          }}
        />
      )
    }

    if (totalUsersWithBirthdayDate === totalUsers) {
      return (
        <IntlMessages
          id="components.birthdaySummaryInfo.allUsersHaveBirthdays"
          values={{
            totalUsers,
            link: (...chunks) => (
              <Link target="_blank" style={{ textDecoration: 'underline' }} to={linkTo}>
                {chunks}
              </Link>
            ),
          }}
        />
      )
    }

    return (
      <IntlMessages
        id="components.birthdaySummaryInfo.someUsersHaveBirthdays"
        values={{
          totalUsersWithBirthdayDate,
          totalUsers,
          link: (...chunks) => (
            <Link target="_blank" style={{ textDecoration: 'underline' }} to={linkTo}>
              {chunks}
            </Link>
          ),
        }}
      />
    )
  }

  return <Alert type="info" showIcon={false} message={getSummaryMessage()} style={{ textAlign: 'left', marginBottom: 24 }} />
}

export default BirthdaySummaryInfo
